import Model from '@/models/Model.js';

export default class AttendanceComment extends Model {
    static entity = 'attendance_comments';

    static fields() {
        return {
            id: this.attr(null),
            attendance_id: this.attr(null),
            time_period_id: this.attr(null),
            user_id: this.attr(null),
            comment: this.attr(null),

            created_by: this.attr(null),

            ...super.fields(),

            attendance: this.belongsTo('attendances', 'attendance_id'),
            time_period: this.belongsTo('time_periods', 'time_period_id'),
            user: this.belongsTo('users', 'user_id'),
            creator: this.belongsTo('users', 'created_by'),
        };
    }
}
